// @flow
import React, { Fragment } from 'react';
import { IconContext } from 'react-icons';
import { IoIosArrowRoundForward } from 'react-icons/io';
import './EstimateGuide.scss';

type Props = {
  descriptions: Array<string>,
};

const ArrowForGuide = () => (
  <IconContext.Provider value={{ color: '#74c0fc', size: '64px', className: 'guide-arrow' }}>
    <div>
      <IoIosArrowRoundForward />
    </div>
  </IconContext.Provider>
);

const EstimateGuide = ({ descriptions }: Props) => {
  // 가이드 이미지
  const baseArray = Array.from(new Array(7).keys());
  const guideImages = baseArray.map(key => {
    return key % 2 !== 0 ? (
      <ArrowForGuide key={`arrow${(key + 1) / 2}`} />
    ) : (
      <div className="guide-image" key={`quote_guide${(key + 2) / 2}`}>
        <img
          src={`${process.env.IMAGES_URL}/estimate/quote_guide${(key + 2) / 2}.png`}
          alt={`quote_guide${(key + 2) / 2}`}
        />
      </div>
    );
  });

  // 가이드 설명
  const guideDescriptions = baseArray.map(key => {
    return key % 2 !== 0 ? (
      <IconContext.Provider
        value={{ color: 'white', size: '56px', className: 'guide-arrow' }}
        key={`arrow${(key + 1) / 2}`}
      >
        <div>
          <IoIosArrowRoundForward />
        </div>
      </IconContext.Provider>
    ) : (
      <p key={`guide_desc${(key + 2) / 2}`}>{descriptions[key / 2]}</p>
    );
  });

  return (
    <Fragment>
      <div className="estimate-guide">{guideImages}</div>
      <div className="estimate-guide-description">{guideDescriptions}</div>
    </Fragment>
  );
};

export default EstimateGuide;



// WEBPACK FOOTER //
// ./src/components/estimate/EstimateGuide/EstimateGuide.js